import { rumEnabled, type RumEnv } from './rumConfig';

// Next.js inlines NEXT_PUBLIC_* only where `process.env.NAME` is written out
// literally, so every read lives here. An empty string is how an unset value
// arrives from a `.env` line with nothing after the `=`; it counts as unset.
const set = (value: string | undefined): string | undefined =>
  value !== undefined && value.trim() !== '' ? value : undefined;

export const rumEnv: RumEnv = {
  applicationId: set(process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID),
  clientToken: set(process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN),
  site: set(process.env.NEXT_PUBLIC_DATADOG_SITE),
  privacyLevel: set(process.env.NEXT_PUBLIC_DATADOG_PRIVACY_LEVEL),
  sessionSampleRate: set(process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE),
  replaySampleRate: set(process.env.NEXT_PUBLIC_DATADOG_REPLAY_SAMPLE_RATE),
  // Vercel exposes NEXT_PUBLIC_VERCEL_ENV ('production' | 'preview' |
  // 'development') when "Automatically expose System Environment Variables" is
  // on for the project; the explicit override is for local runs and other hosts.
  env: set(process.env.NEXT_PUBLIC_DATADOG_ENV) ?? set(process.env.NEXT_PUBLIC_VERCEL_ENV),
  // Injected by next.config.ts from lib/datadog/buildIdentity.mjs, the same
  // helper the source-map upload uses for --release-version. They must match
  // exactly or Datadog cannot de-minify this build's stack traces.
  version: set(process.env.NEXT_PUBLIC_DATADOG_VERSION) ?? set(process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA),
  proxy: set(process.env.NEXT_PUBLIC_DATADOG_PROXY),
  canvasQuality: set(process.env.NEXT_PUBLIC_DATADOG_CANVAS_QUALITY),
};

export const RUM_ENABLED = rumEnabled(rumEnv);
